import { useMemo } from "react"
import { AdditionalModelIdentifier } from "@tm/models"
import { useVehicleUrlParameter } from "@bundles/vehicle/hooks/useVehicleUrlParamter"

export function useAdditionalModelIdentifier(): AdditionalModelIdentifier {
    const vehicleUrlParameter = useVehicleUrlParameter()
    return useMemo(() => {
        let initialRegistration: Date | undefined
        const initialRegistrationString = vehicleUrlParameter.initialRegistration

        if (initialRegistrationString) {
            initialRegistration = new Date(initialRegistrationString)

            if (Number.isNaN(initialRegistration.getTime())) {
                initialRegistration = undefined
            }
        }

        return { plateId: vehicleUrlParameter.plateId, vin: vehicleUrlParameter.vin, initialRegistration }
    }, [vehicleUrlParameter.initialRegistration, vehicleUrlParameter.vin, vehicleUrlParameter.plateId])
}
